import type { ReactNode } from 'react'
import { Sandwich, SandwichBun, SandwichContent } from '@/components/Sandwich'
import { ScrollView } from '@/components/ScrollView'
import styles from './OCRScopingJobSidePanel.module.css'

export interface OCRScopingJobSidePanelProps {
  children?: ReactNode
}

export function OCRScopingJobSidePanel({
  children,
}: OCRScopingJobSidePanelProps) {
  return (
    <Sandwich stretch className={styles.root}>
      {children}
    </Sandwich>
  )
}

export interface OCRScopingJobSidePanelContentProps {
  header: ReactNode
  showList: boolean
  items: ReactNode
  loader: ReactNode
  footer: ReactNode
}

export function OCRScopingJobSidePanelContent({
  header,
  showList,
  items,
  loader,
  footer,
}: OCRScopingJobSidePanelContentProps) {
  return (
    <>
      <SandwichBun>{header}</SandwichBun>
      <SandwichContent>
        {showList && (
          <ScrollView>
            {items}
            {loader}
          </ScrollView>
        )}
      </SandwichContent>
      <SandwichBun>
        <div className={styles.footer}>{footer}</div>
      </SandwichBun>
    </>
  )
}
